import React from 'react'
import {
  ComingSoonButtonContainer,
  ComingSoonContainer,
  ComingSoonContentContainer,
  ComingSoonMainContainer,
  ComingSoonTitle,
  ComingSoonTitleSecondary,
} from './ComingSoon.styled'
import BallLogo from 'assets/icons/ballLogo.svg'
import SVG from 'react-inlinesvg'
import Button from 'components/Button/Button'
import { useHistory } from 'react-router-dom'

const ComingSoon = () => {
  const { goBack } = useHistory()
  return (
    <>
      <ComingSoonContainer>
        <ComingSoonContentContainer>
          <ComingSoonMainContainer>
            <ComingSoonTitle>Coming</ComingSoonTitle>
            <ComingSoonTitleSecondary>Soon</ComingSoonTitleSecondary>
          </ComingSoonMainContainer>
          <SVG src={BallLogo} style={{ marginLeft: '40px' }} />
        </ComingSoonContentContainer>
        <ComingSoonButtonContainer>
          <Button
            text="Previous Page"
            variant="primary"
            size="large"
            style={{ padding: '0px 50px', marginTop: 50 }}
            onClick={() => goBack()}
          />
        </ComingSoonButtonContainer>
      </ComingSoonContainer>
    </>
  )
}

export default ComingSoon
